<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

defineProps({
  keepAlive: {
    type: Boolean,
    default: true,
  },
});

// Full-bleed routes (e.g. the form builder) opt out of the centered, padded
// settings layout so their own multi-column editor can use the full viewport.
const route = useRoute();
const isFullWidth = computed(() => route.meta?.fullWidth === true);
</script>

<template>
  <div
    class="flex flex-col w-full h-full m-0 bg-n-background font-inter"
    :class="
      isFullWidth
        ? 'p-0 overflow-hidden'
        : 'p-6 sm:py-8 lg:px-16 overflow-auto'
    "
  >
    <div
      class="flex w-full"
      :class="isFullWidth ? 'h-full items-stretch' : 'items-start max-w-6xl mx-auto'"
    >
      <router-view v-slot="{ Component }">
        <keep-alive v-if="keepAlive">
          <component :is="Component" />
        </keep-alive>
        <component :is="Component" v-else />
      </router-view>
    </div>
  </div>
</template>
